import React from "react";
import PublishProductionButton from "../../Components/PublishProductionButton";
import { usePermissions } from "../../Auth/PermissionsContext";
import { publierEnProduction } from "./macroProductionPublish";

/** La permission qui autorise la promotion des données macroéconomiques en production. */
export const MACRO_PUBLISH_FEATURE = "macro-publish";

export type MacroPublishAfterSaveButtonProps = {
	/** Appelé quand la promotion a abouti : l'appelant ferme la modale et recharge son état. */
	onPublished?: () => void;
};

/**
 * Le bouton « Mettre en production » de la modale qui suit un import macroéconomique réussi.
 *
 * C'est le MÊME bouton que pour un contenu (même apparence, même confirmation, même traitement du
 * verrou de publication) : seul l'appel change, la macro promouvant tous les sujets modifiés d'un
 * coup au lieu d'un document. Il n'apparaît que si la personne détient la permission de publication
 * macro, le droit que le serveur exige de toute façon sur POST /api/macro/publish-production.
 */
const MacroPublishAfterSaveButton: React.FC<MacroPublishAfterSaveButtonProps> = ({ onPublished }) => {
	const { canFeatureWrite } = usePermissions();
	if (!canFeatureWrite(MACRO_PUBLISH_FEATURE)) return null;

	return (
		<PublishProductionButton
			token={`feature:${MACRO_PUBLISH_FEATURE}:write`}
			label="Mettre en production"
			publishAction={publierEnProduction}
			confirmMessage="Les sujets modifiés par cet import remplaceront ceux en ligne."
			onPublished={onPublished}
			className="inline-flex items-center gap-2 rounded-full bg-[#005CA9] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-[#004b8a] disabled:cursor-not-allowed disabled:bg-slate-300"
		/>
	);
};

export default MacroPublishAfterSaveButton;
